"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * SDK Core UUID
 *
 * uuid generation
 *
 * @module core-uuid
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Secure implementation of Math.random
 *
 * @param {object} cryptoObj A cryptographically secure PRNG
 * @return {number} A cryptographically secure random number netween 0 and 1
 */
function secureMathRandom(cryptoObj) {
  // Divide a random UInt32 by the maximum value (2^32 -1) to get a result between 0 and 1
  return cryptoObj.getRandomValues(new Uint32Array(1))[0] / 4294967295;
}

/**
 * builds an rfc4122 version 4 uuid
 * http://stackoverflow.com/a/2117523
 *
 * re: NOSONAR below, we are using bitwise operators on purpose here
 *
 * @return {string} An rfc4122 version 4 compliant UUID
 */
function uuid() {
  // check if we have any cryptographically secure PRNGs
  var cryptoObj = window.crypto || window.msCrypto;
  if (!cryptoObj) {
    // we don't have a cryptographically secure PRNG so we cannot generate a UUID
    return null;
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = secureMathRandom(cryptoObj) * 16 | 0; // NOSONAR
    var v = c === 'x' ? r : r & 0x3 | 0x8; // NOSONAR
    return v.toString(16);
  });
}
var _default = exports["default"] = {
  uuid: uuid
};
//# sourceMappingURL=index.js.map